export interface Storage {
  getItem: (key: string) => any;
  setItem: (key: string, value: any) => any;
  removeItem: (key: string) => any;
  clear: () => void;
}

export abstract class StorageService {
  storage: Storage;

  public getItem<T = any>(key: string): T {
    const value = this.storage.getItem(key);
    try {
      // TODO: Try find a fix for this when you save a string, because you will get a number
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return JSON.parse(value);
    } catch {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return value;
    }
  }

  public setItem(key: string, value: any) {
    try {
      const val = typeof value === 'object' ? JSON.stringify(value) : value;
      this.storage.setItem(key, val);
      return true;
    } catch {
      return false;
    }
  }

  public setItems(items: Record<string, unknown>) {
    Object.entries(items).forEach(([key, value]) => this.setItem(key, value));
  }

  public removeItem(key: string) {
    try {
      this.storage.removeItem(key);
      return true;
    } catch {
      return false;
    }
  }

  public removeItems(...items: string[]) {
    return items.map(key => this.removeItem(key));
  }

  public clear() {
    this.storage.clear();
    return true;
  }
}
